import dataApplicationsContext from "../../context/dataApplicationsContext"
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { useScrollLock } from "../../hooks/useScrollLock";
import { useGetAllTopicsQuery } from "../../slices/topicsApiSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNewspaper } from "@fortawesome/free-regular-svg-icons";

const MobilSearch = () => {
  const { isSearchActive, setIsSearchActive, search, setSearch, windowWidth, searchInputRef } = useContext(dataApplicationsContext);
  const { data: topics, isLoading, isSuccess, isError, error } = useGetAllTopicsQuery();

  const navigate = useNavigate();
  const [displayArticles, setDisplayArticles] = useState([]);
  const { lockScroll, unlockScroll } = useScrollLock();
  const [articles, setArticles] = useState([
    // Pour les articles principaux quand search est vide
    { suggestion: "Rechercher des compétitions", path: '/topics/rechercher/26' },
    { suggestion: "Supprimer mon compte", path: '/topics/compte/12' },
    { suggestion: "Gestion portail organisateur", path: '#' }
  ]);

  const handleReset = (e) => {
    setSearch('')
  }

  const handleSearch = (e) => {
    setSearch(e.target.value);
  }

  const handleClose = () => {
    setSearch('');
    setIsSearchActive(false)
  }
  
  const handleNavigate = (link) => {
    navigate(link);
    window.scrollTo(0,0);
    setIsSearchActive(false)
  }

  
  useEffect(() => {
    if (search.length > 0 && isSuccess) {
      const articlesResults = topics.filter((article) => {
        const lowerSearch = search
          .toLowerCase()
          .replace(/[-_\s]/g, "") // Remove '-', '_' and spaces
          .normalize("NFD") // Decompose accented characters
          .replace(/[\u0300-\u036f]/g, ""); // Remove diacritics
          
        const hasMatchingTag = article.tags?.some(tag => 
          tag.toLowerCase().startsWith(lowerSearch)
        );
        if (hasMatchingTag) {
          return article
        }
      })

      setDisplayArticles([[{suggestion: search}], articlesResults].flat())
    }
  }, [search, isSuccess]);



  useEffect(() => {
    if (isSearchActive) {
      lockScroll();
      // Simple focus avec un délai pour l'animation
      const timer = setTimeout(() => {
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }, 350);
      return () => {
        clearTimeout(timer);
      };
    } else {
      unlockScroll();
    }
  }, [isSearchActive]);




  const handleSubmit = (e) => {
    e.preventDefault(); // Empêche le rechargement de la page
    if (search.trim()) { // Vérifie que la recherche n'est pas vide
      // Encode la recherche pour l'URL
      const searchQuery = encodeURIComponent(search.trim());
      // Navigate vers la page de recherche avec le query parameter
      handleNavigate(`/search?q=${searchQuery}`);
    }
  };

  const handleSuggest = (suggestion) => {
    handleNavigate(`/search?q=${suggestion}`);
  }

  
  // if (isLoading) return <PulseLoader color='#e1004a' className='user-setting-container help' size={10} />

  return (
    <div className={`mobil-search ${isSearchActive ? 'active' : ''}`}>
      <div className="search-wrapper">
        <i className={`bi bi-chevron-left mobil-close-search`} onClick={handleClose}></i>
        <form className={`chart-search-container w-84p mr-0`} onSubmit={handleSubmit}>
          <i className={`fa-solid fa-magnifying-glass loupe op-6`}></i>
          {search.length > 0 && <i className={`bi bi-x-lg close-search`} onClick={handleReset}></i>}
          <input 
            autoComplete="off"  type="text"  className='chart-search-input min-h-40' 
            placeholder={windowWidth >= 400 ? 'Rechercher des guides pratiques et plus' : "Rechercher dans l'aide"}
            value={search} onChange={handleSearch} ref={searchInputRef}
            inputMode="search"
            enterKeyHint="search"
          />
        </form>
      </div>
      <div className="search-content-container mt-32">
        <p className="fz-16 fw-600 op-9">Articles principaux</p>
        <div className="news-container">
          {search.length === 0 &&
            articles.map((article, index) => {
              return (
                <div className={`article pt-8 pb-8`} key={`article-${index}`} onClick={() => handleNavigate(article.path)}>
                  <FontAwesomeIcon icon={faNewspaper} className="article-icon fz-18"/>
                  <p className="fz-16 fw-500">{article.suggestion}</p>
                </div>
              );
            })
          }
        </div>
      </div>
      {(search?.length > 0 && displayArticles?.length > 0) && 
        <div className="mt-24">
          {displayArticles.slice(0,6).map((article, index) => {
            return (
              <div className={`article ${index > 0 ? 'pt-6' : 'pt-0'} pb-6 gap-24`} key={`suggestion-${index}`} onClick={() => handleSuggest(article.suggestion)}>
                <i className={`fa-solid fa-magnifying-glass article-icon fz-14`}></i>
                <p className="fw-500 fz-16">{article.suggestion}</p>
              </div>
            )
          })}
        </div>
      }
    </div>
  )
}

export default MobilSearch